"use strict";

const filterProducts = (product, selectedProducts) => selectedProducts.some(selectedProduct => selectedProduct.productId === product.id);
export { filterProducts };
//# sourceMappingURL=filterProducts.mjs.map
